<template>
  <mds-alert
    v-if="showAlert"
    v-bind:variation="alertVariation"
    v-bind:title="alertTitle"
    tinted
    @mds-alert-dismissed="closeAlert"
  >
    {{ alertMessage }}
  </mds-alert>
  <div style="overflow-y: auto">
    <mds-card
      style="width: 100%"
      :title="
        'Upload Files for Event Id : ' +
        eventIdProp +
        ' Event Name :' +
        eventNameProp
      "
      caption="Select and Upload Files here"
    >
      <template #mds-card-action>
        <div style="display: flex; justify-content: space-between">
          <p
            v-if="showFileExt"
            style="color: #005ba1; font-weight: bold; margin-bottom: 1%"
          >
            Supported File Types [ {{ fileExt }} ]
          </p>
          <p
            v-if="isEditClicked"
            style="
              float: right;
              margin-right: 10%;
              color: red;
              font-weight: bold;
            "
          >
            You are editing the details for Id {{ id }}
          </p>
        </div>
        <mds-form>
          <mds-fieldset id="fsUpload" horizontal>
            <mds-select
              id="slFileType"
              :disabled="isFileTypeDisabled"
              required
              requiredText="This field is required"
              placeholder="Select an Option"
              v-model="fileType"
              label="File Type"
              @click="fileTypeChange()"
              @change="onChangeDropDown($event)"
              :options="[
                { text: 'Presentation', value: 'Presentation' },
                { text: 'Transcript', value: 'Transcript' },
              ]"
            ></mds-select>
            <mds-input
              v-if="!isVisible"
              id="inLinkUrl"
              size="medium"
              :disabled="showLoader"
              label="Link Url"
              placeholder="Enter Link Url"
              v-model="linkUrl"
            ></mds-input>
            <mds-input
              v-if="isVisible"
              id="inDocumentId"
              size="medium"
              :disabled="showLoader"
              label="Document Id"
              placeholder="Enter Document Id"
              v-model="documentId"
              Type="number"
              min="0"
              oninput="this.value = Math.abs(this.value)"
            ></mds-input>
            <input
              type="File"
              id="fileUpload"
              hidden
              ref="fileInput"
              style="background-color: #e5e5e5; width: 70%"
              @change="handleFileChange"
            />
            <mds-input
              v-if="!isVisible"
              id="inChooseFile"
              style="background-color: #e5e5e5; color: black"
              placeholder="Click to Choose File"
              v-model="chooseFile"
              readonly
              size="medium"
              :disabled="disableField"
              v-bind:label="'Select File'"
              v-on:click.prevent="chooseFiles()"
            ></mds-input>
            <div style="margin-top: 2%; margin-left: 5%">
              <mds-button
                style="margin-left: 5%"
                size="medium"
                variation="primary"
                v-on:click.prevent="save()"
                :disabled="disableField"
                >Save</mds-button
              >
              <mds-button
                style="margin-left: 5%"
                size="medium"
                variation="primary"
                v-on:click.prevent="clear()"
                :disabled="disableField"
                >Clear</mds-button
              >
            </div>
          </mds-fieldset>
          <!-- <div style="width: 100%; margin-top: 5px; margin-bottom: 5px">
            <table style="width: 100%">
              <tr style="width: 100%">
                <td style="width: 3%">
                  <div v-if="uploadProgress > 0" style="font-weight: bold">
                    {{ uploadProgress }}%
                  </div>
                </td>
                <td style="width: 97%">
                  <progress
                    v-if="uploadProgress > 0"
                    :value="uploadProgress"
                    max="100"
                    style="
                      width: 100%;
                      height: 20px;
                      border-radius: 5px;
                      margin: 0;
                      background-color: blue;
                    "
                  ></progress>
                </td>
              </tr>
            </table>
            </div> -->
        </mds-form>
        <br />
        <div>
          <mds-pagination
            show-items-info
            show-items-select
            :total-items="100"
          ></mds-pagination>
          <mds-table zebra-stripes>
            <mds-thead>
              <mds-th style="width: 10%"> Id </mds-th>
              <mds-th style="width: 10%"> Event Id </mds-th>
              <mds-th style="width: 10%"> File Type </mds-th>
              <mds-th style="width: 40%"> File Name </mds-th>
              <mds-th style="width: 10%"> Document Id </mds-th>
              <mds-th style="width: 10%"> Link Url </mds-th>
              <mds-th style="width: 10%"> Status </mds-th>
              <mds-th style="width: 10%"> Updated Date </mds-th>
              <mds-th style="width: 10%"> Edit Records </mds-th>
            </mds-thead>
            <mds-tbody>
              <mds-tr v-for="event in uploadedDetails" :key="event.id">
                <mds-td> {{ event.id }} </mds-td>
                <mds-td> {{ event.eventId }} </mds-td>
                <mds-td> {{ event.fileType }} </mds-td>
                <mds-td style="word-wrap: break-word">
                  {{ event.fileName }}
                </mds-td>
                <mds-td> {{ event.documentId }} </mds-td>
                <mds-td
                  ><a
                    style="cursor: pointer"
                    v-bind:title="event.fileUrl"
                    v-if="event.fileUrl != ''"
                    @click="openUrl(event.fileUrl)"
                    >View Url</a
                  ></mds-td
                >
                <mds-td> {{ event.uploadStatus }} </mds-td>
                <mds-td> {{ formatDate(event.createdDate) }} </mds-td>
                <mds-td>
                  <mds-button
                    size="medium"
                    @click="edit(event)"
                    :disabled="disableField || isAudioFileType(event.fileType)"
                  >
                    Edit
                  </mds-button>
                </mds-td>
              </mds-tr>
            </mds-tbody>
          </mds-table>
        </div>
      </template>
    </mds-card>
  </div>
</template>

<script>
import axiosInstance from "@/AxiosTokenInstance";
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd,
} from "@mds/data-table-vue3";
import MdsForm from "@mds/form-vue3";
import MdsCard from "@mds/card-vue3";
import MdsComboBox from "@mds/combo-box-vue3";
import MdsInput from "@mds/input-vue3";
import MdsSelect from "@mds/select-vue3";
import MdsFieldset from "@mds/fieldset-vue3";
import { MdsButton } from "@mds/button-vue3";
import MdsDatePicker from "@mds/date-picker-vue3";
import { mapState, mapActions, mapMutations } from "vuex";
import MdsLoader from "@mds/loader-vue3";
import moment, * as moments from "moment";
import config from "../../config";
import MdsAlert from "@mds/alert-vue3";
import * as signalR from "@microsoft/signalr";
export default {
  name: "FileUpload",
  components: {
    MdsCard,
    MdsForm,
    MdsComboBox,
    MdsSelect,
    MdsInput,
    MdsFieldset,
    MdsButton,
    MdsDatePicker,
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsLoader,
    MdsAlert,
  },
  data() {
    return {
      eventList: [],
      isFileTypeDisabled: false,
      selectedFile: null,
      fileType: "",
      linkUrl: "",
      documentId: "",
      id: 0,
      selectedEvent: null,
      connection: null,
      showAlert: false,
      uploadProgress: 0,
      connection: null,
      fileExt: "",
      showFileExt: false,
      chooseFile: "",
      isUrlSync: false,
      alertTimer: "",
      isEditClicked: false,
      isEditableFileName: "",
      disableField: false,
      isVisible: true,
    };
  },
  props: {
    eventIdProp: Number,
    eventNameProp: String,
    uploadedDetails: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.clear();
  },
  methods: {
    onChangeDropDown(event) {
      if (this.fileType) {
        this.acceptFiles(event.target.value);
      }
    },
    isAudioFileType(fileType) {
      return fileType.toLowerCase() === "audio";
    },
    setAlert(flag, tile, message, varation) {
      this.showAlert = flag;
      this.alertTitle = tile;
      this.alertMessage = message;
      this.alertVariation = varation;
      if (flag) this.autoCloseAlert();
    },
    closeAlert() {
      this.setAlert(false, "", "", "");
      if (this.alertTimer) clearTimeout(this.alertTimer);
    },
    autoCloseAlert() {
      this.alertTimer = setTimeout(() => {
        this.closeAlert();
      }, config.alertTime * 1000);
    },
    validURL(str) {
      try {
        const newUrl = new URL(str);
        return newUrl.protocol === "http:" || newUrl.protocol === "https:";
      } catch (err) {
        return false;
      }
    },
    // Not in used
    validateUrl(str) {
      var urlPattern = new RegExp("^(http|https)://", "i");
      if (urlPattern.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    edit(event) {
      this.isFileTypeDisabled = true;
      this.closeAlert();
      this.fileType = event.fileType;
      this.linkUrl = event.fileUrl;
      this.selectedEvent = event;
      this.id = event.id;
      this.isEditableFileName = event.fileName;
      this.chooseFile = "";
      this.isUrlSync = event.isUrlSync;
      this.documentId = event.documentId;
      this.fileTypeChange();
      document.getElementById("slFileType").focus();
      this.isEditClicked = true;
    },
    clear() {
      this.clearUplodForm();
      this.closeAlert();
      this.isFileTypeDisabled = false;
      this.isEditClicked = false;
      this.isEditableFileName = "";
    },
    clearUplodForm() {
      document.getElementById("fileUpload").removeAttribute("accept");
      this.fileType = "";
      this.linkUrl = "";
      this.selectedEvent = null;
      this.selectedFile = null;
      this.id = 0;
      this.showFileExt = false;
      this.chooseFile = "";
      this.isUrlSync = false;
      this.documentId = "";
      this.isVisible = true;
      const fileInput = this.$refs.fileInput;
      if (fileInput) {
        fileInput.value = null;
      }
    },
    fileTypeChange() {
      if (this.fileType) {
        this.acceptFiles(this.fileType);
      }
    },
    acceptFiles(fileType) {
      if (fileType == "Audio") {
        this.showFileExt = true;
        this.isVisible = false;

        this.fileExt = config.audioFileType.replaceAll(".", "");
        document.getElementById("fileUpload").accept = config.audioFileType;
      }
      if (fileType == "Presentation") {
        this.isVisible = true;
        this.showFileExt = false;
        this.fileExt = config.pptFileType.replaceAll(".", "");
        document.getElementById("fileUpload").accept = config.pptFileType;
      }
      if (fileType == "Transcript") {
        this.isVisible = true;
        this.showFileExt = false;
        this.fileExt = config.transcriptFileType.replaceAll(".", "");
        document.getElementById("fileUpload").accept =
          config.transcriptFileType;
      }
    },
    chooseFiles() {
      document.getElementById("fileUpload").click();
    },
    async handleFileChange(event) {
      // Handle file selection
      this.selectedFile = event.target.files[0];
      this.chooseFile = this.selectedFile.name;
    },
    async save() {
      this.closeAlert();

      if (this.fileType == "" || this.fileType == null) {
        this.setAlert(
          true,
          "Warning Alert",
          "Please select File Type",
          "warning"
        );
        return;
      }

      if (
        (this.selectedFile == "" || this.selectedFile == null) &&
        (this.linkUrl == "" || this.linkUrl == null) &&
        this.fileType == "Audio"
      ) {
        this.setAlert(
          true,
          "Warning Alert",
          "Please enter atleast any one input from Link Url or Choose File",
          "warning"
        );
        return;
      }

      if (
        (this.fileType == "Presentation" || this.fileType == "Transcript") &&
        this.documentId == ""
      ) {
        this.setAlert(
          true,
          "Warning Alert",
          "Please enter Document Id",
          "warning"
        );
        return;
      }

      if (this.selectedFile) {
        const arrfileExt = this.fileExt.replaceAll(".", "").split(",");
        var ext = this.selectedFile.name.split(".").pop();
        if (!arrfileExt.includes(ext)) {
          this.setAlert(
            true,
            "Warning Alert",
            ext + " type file not supported for " + this.fileType,
            "warning"
          );
          return;
        }

        //In edit file name should be same

        if (
          this.isEditClicked == true &&
          this.isEditableFileName != "" &&
          this.isEditableFileName != this.selectedFile.name
        ) {
          this.setAlert(
            true,
            "Warning Alert",
            "While editing FileName should be same",
            "warning"
          );
          return;
        }

        //Duplicate File Name Issue

        if (this.fileType != "" && this.selectedFile.name != "") {
          for (var i = 0; i < this.uploadedDetails.length; i++) {
            if (
              this.uploadedDetails[i].fileType == this.fileType &&
              this.uploadedDetails[i].fileName == this.selectedFile.name &&
              this.isEditClicked == false
            ) {
              // alert ('upload'+this.uploadedDetails[i].fileType+ ','+this.uploadedDetails[i].fileName+ ','+this.isEditClicked+','+this.selectedFile.name);
              this.setAlert(
                true,
                "Warning Alert",
                "You are uploading under the same FileType with same File Name, Rename the file name for upload",
                "warning"
              );
              return;
            }
          }
        }
      }
      if (!this.validURL(this.linkUrl) && this.linkUrl) {
        this.setAlert(
          true,
          "Warning Alert",
          "Link Url is not valid",
          "warning"
        );
        return;
      }
      if (this.selectedFile) {
        try {
          this.$emit("showModelLoader", true);
          this.disableField = true;
          this.connection = new signalR.HubConnectionBuilder()
            .withUrl(`${config.api_url}fileHub`, {
              skipNegotiation: true,
              transport: signalR.HttpTransportType.WebSockets,
            })
            .build();

          await this.connection.start();

          this.connection.on("ReceiveProgress", (progress) => {
            this.uploadProgress = progress == 0 ? 1 : progress;
          });

          await this.connection.invoke("SendProgress", 0);
        } catch (error) {
          this.setAlert(true, "Error Alert", error, "error");
          this.$emit("showModelLoader", false);
          this.disableField = false;
        }
      }
      try {
        this.isFileTypeDisabled = true;
        this.$emit("showModelLoader", true);
        this.disableField = true;
        const apiUrl = `${config.api_url}ConferenceCallTracker/upload`;
        const createdByValue = parseInt(this.userDetails.data.userId, 10);
        const formData = new FormData();

        formData.append("file", this.selectedFile); // Use 'file' as the key
        formData.append("eventId", this.eventIdProp);
        formData.append("fileType", this.fileType);
        formData.append("fileUrl", this.linkUrl);
        formData.append("createdBy", createdByValue);
        formData.append("id", this.id);
        formData.append("isUrlSync", this.isUrlSync);
        formData.append(
          "documentId",
          this.documentId == null ? -1 : this.documentId
        );

        const response = await axiosInstance.post(apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        // Check for duplicate DocumentId response
        if (response.data.message === "DUPLICATE") {
          this.setAlert(
            true,
            "Warning Alert",
            "Duplicate DocumentId found",
            "warning"
          );
          return;
        }

        if (response.data.success) {
          this.setAlert(
            true,
            "Success Alert",
            response.data.message,
            "success"
          );
          this.clearUplodForm();
        } else
          this.setAlert(true, "Error Alert", response.data.message, "error");
      } catch (error) {
        this.setAlert(true, "Error Alert", error, "error");
      } finally {
        if (this.connection) {
          await this.connection.stop();
        }
        await this.getUploadedData();
        this.uploadProgress = 0;
        this.clear();
      }
    },
    async getUploadedData() {
      await axiosInstance
        .get(
          `${config.api_url}ConferenceCallTracker/get-upload-data?eventId=${this.eventIdProp}&webcastUrl=null`
        )
        .then((response) => {
          if (response.data.success)
            this.$emit("updateDetails", response.data.data.uploadedData);
          else
            this.setAlert(true, "Error Alert", response.data.message, "error");
          this.isFileTypeDisabled = false;
          this.$emit("showModelLoader", false);
          this.disableField = false;
        })
        .catch((error) => {
          this.setAlert(true, "Error Alert", error, "error");
          this.$emit("showModelLoader", false);
          this.disableField = false;
        });
    },

    openUrl(url) {
      window.open(url, "_blank");
    },
    formatDate(date) {
      var formatedDate = moment(date).format("YYYY-MM-DD");
      return formatedDate;
    },
  },
  computed: {
    ...mapState("auth", {
      userDetails: (state) => state.userDetails,
    }),
  },
};
</script>
<style lang="scss" module>
*,
#fieldset1::before,
#fieldset1::after {
  margin-right: 15px;
}
::-webkit-progress-value {
  background-color: rgb(79, 136, 201) !important;
}
</style>
